export default {
  // 自定義後臺數據
  custom_backstage: {
    customApp: '自定義應用',
    expertsService: '專家定制服務',
    selectAppTemplate: '選擇應用模版',
    creatNewApp: '創建新的應用',
    juhe: '聚合表',
    app: '應用',
    module: '模塊',
    myApp: '我的應用',
    uploadApp: '上傳應用',
    noNameApp: '未命名應用',
    editIcon: '編輯圖標',
    appName: '應用名稱',
    moduleName: '模塊名稱',
    moduleType: '模塊類型',
    creatModule: '創建模塊',
    newBuildModule: '新建模塊',
    editModule: '編輯模塊',
    creatApp: '創建應用',
    editApp: '編輯應用',
    name: '名稱',
    moduleIcon: '模塊圖標',
    creater: '創建人',
    createTime: '創建時間',
    nameMustfill: '名稱必填',
    modifyPer: '修改人',
    modifyTime: '修改時間',
    transfer: '轉移',
    transferTo: '轉移給',
    transferToShare: '轉移後共享給當前數據分析負責人',
    transferAfter: '將當前數據的負責人轉移給其他負責人? 轉移成功後，改操作將無法恢復',
    selectTransferPer: '請選擇轉移人員',
    transferComplete: '轉移成功',
    rongjiuDelDataIsGoon: '此操作將永久刪除該數據, 是否繼續?',
    juheName: '聚合表名稱',
    dataSource: '數據源',
    nodataRightadd: '暫無數據，請從右側添加～',
    theDataSource: '數據來源',
    rowTable: '行表頭',
    add: '添加',
    guanlianField: '關聯字段',
    columnTable: '列表頭',
    tongjizhibiao: '統計指標',
    screenContion: '篩選條件',
    visibility: '可見性',
    kexuanbumen: '可選擇部門、成員、角色, 支持多選',
    run: '運 行',
    oneTabledata: '單表數據',
    moreTableGuanlian: '多表關聯',
    dataTable: '數據表',
    selectGuanlianData: '請選擇關聯數據',
    jianyanInfo_1: '數據來源不能為空',
    jianyanInfo_2: '行表頭、列表頭、統計指標中, 至少有壹個主表字段',
    jianyanInfo_3: '行表頭不能為空',
    jianyanInfo_4: '統計指標不能為空',
    jianyanInfo_5: '聚合表名稱不能為空',
    jianyanInfo_6: '統計指標名稱不能為空',
    jianyanInfo_7: '統計指標公式不能為空',
    jianyanInfo_8: '統計指標名稱不能重復',
    jianyanInfo_9: '數據還未保存,是否退出?',
    jianyanInfo_10: '數據表最多選擇5個',
    jianyanInfo_11: '該數據已存在',
    jianyanInfo_12: '數據表不能為空',
    jianyanInfo_13: '字段關聯不能為空',
    jianyanInfo_14: '此操作將重置之前設置的參數, 是否繼續?',
    appNameNotEmpty: '應用名稱不能為空',
    uploaderNotEmpty: '上傳人不能為空',
    onePicUpload: '請至少上傳壹張應用圖片',
    descNotEmpty: '描述不能為空',
    priceNotEmpty: '價格不能為空',
    formatError: '格式錯誤',
    accountNotEmpty: '賬號不能為空',
    appDetail: '應用詳情',
    baseInfo: '基本信息',
    Industry: '所屬行業',
    appType: '應用分類',
    uploader: '上傳人',
    appScreenshot: '應用截圖',
    uploadPic8: '請上傳該應用的Web端和App端截圖, 總共不超過8張',
    functionInfo: '功能介紹',
    appDesc: '應用描述',
    payInfo: '收費信息',
    ifPay: '是否收費',
    Price: '價格',
    receivingAccount: '收款賬號',
    payInfoToTeamface:
      '每壹筆付款都需要經過7天的資金審核期, 結束後款項會自動打入賬號; 收款賬號非常重要,請謹慎填寫;如填寫有誤, 請及時聯系客服人員',
    penddingShenhe: '提交成功, 請等待系統審核!',
    seeeProgress: '您可以在“應用中心—我的上傳”中查看進度',
    free: '免費',
    pay: '付費',
    alipay: '支付寶',
    wechat: '微信',
    oneInputOneOption: '每行可輸入壹個選項',
    moveModule: '移動模塊',
    suoshuApp: '所屬應用',
    pleaseInputDelModuleName: '請輸入需刪除的模塊名稱',
    appHaveModule: '應用下存在模塊,請先刪除模塊',
    sureDelApp: '刪除後將不可恢復,確定要刪除該應用嗎?',
    moduleNameInputError: '模塊名稱填寫錯誤',
    pageLayout: '頁面布局',
    approvalProcess: '審批流程',
    globalSettings: '全局設置',
    moduleRelease: '模塊發布',
    noAuthOperateApprovalProcess: '無權操作審批流程',
    pleaseSaveCustomLayout: '請先保存自定義布局',
    highContionSet: '高級條件設置',
    before: '以前',
    after: '以後',
    highContion: '高級條件',
    addFilterContion: '添加過濾條件',
    illegalFormula: '公式不合法',
    pleaseInputFormula: '請正確填寫公式',
    contionSetWarning: '條件設置有誤',
    contionFormula: '條件公式',
    contionMax2: '條件大於等於2條才能使用高級條件',
    highContionInfo1: '註意：1. 不允許出現不存在的序號;',
    highContionInfo2: '例：1 and 2 and 3 and 4...',
    highContionInfo3: '2. 有and和or，必須要有括號;',
    highContionInfo4: '例：1 and 2 or 3 、(1 and 2) and 3 or 4;',
    highContionInfo5: '(1 and 2) or (3 or 4) and (5 or 6);',
    highContionInfo6: '(1 and 2 or 3) and 4',
    highContionInfo7: '3. 壹個括號不能同時出現and 和or;',
    highContionInfo8: '例：(1 and 2 or 3 and 4; 括號都是成對出現的;',
    highContionInfo9: '可以使用 OR,AND,NOT和英文括號將上列條件組成邏輯關系;',
    highContionInfo10: '例如：(1 AND 2) OR 3 表示第壹和第二個條件與關系後，再和第三個條件或運算;',
    selectInsetField: '選擇插入字段',
    selectSubformName: '選擇子表名稱',
    selectFieldName: '選擇字段名稱',
    selectSubModule: '選擇子模塊',
    fun: '函數',
    AllFunType: '所有函數類別',
    insertFun: '插入所選函數',
    insertYunsuanfu: '插入運算符',
    operator: '運算符',
    manzuContionShowThisMsg: '在滿足條件公式下顯示此消息',
    gongshiErrorOnlyone: '公式有誤，請至少選擇插入壹個函數',
    formulaDontUseTihua: '公式內容不能包含【"】符號，請用【\'】替換',
    fieldNothereFormulaSetting: '字段不存在，請重新調整公式設置',
    CdtFormulaRequired: '條件公式必填',
    tipsTextRequired: '提示文字必填',
    ordinalParameter: '序號參數',
    submitCheck: '提交校驗',
    formula: '簡單公式',
    functionformula: '函數公式',
    citeformula: '引用公式',
    seniorformula: '高級公式',
    fixedValue: '固定值',
    sequenceNumber: '順序號',
    sequenceNumberRequired: '順序號為必填項',
    identiferInfo1: '1. 固定值：輸入文字或字母皆可',
    identiferInfo2: '2. 年月日：{yyyy} =年; {MM} =月；{dd} =日',
    identiferInfo3: '3. 順序號：{0001}=順序號。可定義數字位數及起始數字',
    identiferInfo4: '例如{00002}， 表示順序號為5位數, 下壹編號從2開始自動計算',
    chanceStyle: '更換樣式',
    systemInfo: '系統信息',
    mobilePhone: '手機',
    wenben: '文本',
    personnel: '人員',
    currentPersonnel: '當前成員',
    text: '單行文本',
    textarea: '多行文本',
    multitext: '富文本',
    picklist: '下拉選項',
    phone: '電話',
    email: '電子郵箱',
    number: '數字',
    datetime: '日期/時間',
    attachment: '附件',
    url: '超鏈接',
    location: '定位',
    picture: '圖片',
    multi: '復選框',
    mutlipicklist: '多級下拉',
    department: '部門',
    onlyDepartmentVisible: '僅所屬部門可見',
    area: '省市區',
    identifier: '自動編號',
    serialnum: '流水號',
    reference: '關聯關系',
    subform: '子表單',
    barcode: '條碼',
    resumeanalysis: '簡歷解析',
    signature: '手寫簽名',
    changyongField: '常用字段',
    fieldComponent: '字段組件',
    baseField: '基礎字段',
    seniorComponent: '高級類組件',
    highVersionComponent: '更高版本組件',
    businessComponent: '業務組件',
    carModel: '車型配置解析',
    queryPlatforms: '查詢第三方平臺',
    aiImageTextRecognition: 'AI圖文識別',
    thisOperateDelSetIsgoon: '此操作將永久刪除該組件及組件的屬性設置?',
    thisOperateIsGoon: '是否繼續?',
    warning: '警告',
    moduleChangeIsSave: '模塊內容有更改, 是否需要保存?',
    fieldNameNotEmpty: '字段名稱不能為空',
    moduleNameNotEmpty: '模塊名稱不能為空',
    moduleTypeNotEmpty: '模塊類型不能為空',
    templateModule: '模版模塊',
    pleaseInputTemplateName: '請輸入需刪除的模板名稱',
    customTemplate: '自定義模版',
    projectTemplate: '協作模版',
    taskTemplate: '任務模版',
    platformTemplate: '平臺模版',
    moduleSet: '模塊設置',
    detailsControl: '詳情控件',
    terminal: '終端',
    setAppearance: '設置外觀',
    themeStyle: '主題樣式',
    attributeStyle: '屬性樣式',
    holisticStyle: '整體樣式',
    pageBackground: '頁面背景',
    tableHeadStyle: '表頭樣式',
    headBackground: '頭部背景',
    mainTitle: '主標題',
    moduleDesc: '模塊描述',
    descText: '描述文字',
    contentStyle: '內容樣式',
    contentBackground: '內容背景色',
    submitStyle: '提交區樣式',
    submitBackground: '提交背景',
    submitStyleNew: '提交樣式',
    submitFeedback: '提交反饋',
    buttonColor: '按鈕顏色',
    selectColor: '選擇顏色',
    buttonShow: '按鈕顯示',
    singleButton: '單按鈕',
    dobuleButton: '雙按鈕',
    buttonText: '按鈕文字',
    buttonWidth: '按鈕寬度',
    buttonPosition: '按鈕位置',
    moduleAppearance: '模塊外觀',
    columnsSet: '分欄設置',
    columnsName: '分欄名稱',
    showHidden: '顯示/隱藏',
    defaultHiddenColumn: '默認收起分欄',
    addEditHiddenCloumnName: '在新增／編輯頁隱藏分欄名稱',
    addEditHiddenCloumn: '在新增／編輯頁隱藏',
    detailsHiddenCloumn: '在詳情頁隱藏',
    fieldSet: '字段設置',
    fieldName: '字段名稱',
    tipsText: '提示文字',
    default: '默認值',
    mappingField: '映射字段',
    set: '設置',
    type: '類型',
    optionContent: '選項內容',
    batchAdd: '批量添加',
    digit: '位數',
    decimalDigit: '小數位數',
    fengefu: '分隔符',
    inputRange: '輸入範圍',
    dontInputUnlimited: '不填代表無限制',
    numberControl: '數量控制',
    noLimit: '不限制',
    limit: '限制',
    sizeRequire: '尺寸要求',
    yiji: '壹級',
    erji: '二級',
    sanji: '三級',
    twoPulldown: '二級下拉',
    threePulldown: '三級下拉',
    oneOption: '壹級選項',
    twoOption: '二級選項',
    threeOption: '三級選項',
    addOption: '添加選項',
    oneDefault: '壹級默認值',
    twoDefault: '二級默認值',
    threeDefault: '三級默認值',
    chooseRange: '可選範圍',
    setFormula: '設置公式',
    dataType: '數據類型',
    returnType: '返回類型',
    jingquedu: '精確度',
    bianhaoResult: '編號結果',
    setBianhaoRule: '設置編號規則',
    referenceModule: '關聯模塊',
    referenceField: '關聯字段',
    buttonConfig: '按鈕配置',
    listSearchField: '列表搜索字段',
    scan: '掃碼',
    barcordComponent: '該功能僅對平台移動端有效且關聯模塊必須保存有條碼組件',
    scanInput: '掃碼輸入',
    onlyOneSetScan: '只允許設置壹個掃碼功能',
    setScreenContion: '設置關聯篩選條件',
    addScreenContion: '添加篩選條件',
    subformStyle: '子表單樣式',
    table: '表格',
    card: '卡片',
    subformField: '子表單字段',
    selectFIeldAddToTable: '選擇字段添加到子表單',
    subfromDefalut: '子表單默認值',
    ifEditShowDefaultSet: '是否編輯頁無值顯示默認設置',
    addressLocation: '地址位置',
    defaultLocation: '默認當前位置',
    serialnumFule: '流水號規則',
    field: '字段',
    date: '日期',
    addFule: '添加規則',
    fieldWidth: '字段寬度',
    singleColumn: '單列',
    doubleColumn: '雙列',
    threeCloumn: '三列',
    fourCloumn: '四列',
    fieldStructure: '字段結構',
    leftRightLayout: '左右布局',
    topBottomLayout: '上下布局',
    fieldControl: '字段控制',
    redayOnly: '只讀',
    noControl: '不控制',
    fieldAuth: '字段權限',
    addShow: '新增時顯示',
    editShow: '編輯時顯示',
    detailShow: '詳情時顯示',
    radio: '單選',
    multiple: '多選',
    phoneNumber: '手機號碼',
    domestic11: '國內11位',
    unlimited: '不限',
    ProjectMembers: '項目成員',
    currentDepartment: '當前部門',
    provinceCity: '省市',
    province: '省',
    city: '市',
    area1: '區',
    currentTime: '當前時間',
    zhidingTime: '指定時間',
    checkedRepeat: '查重',
    donotEnablecheckdRepeat: '不啟用查重',
    enablecheckdRepeat1: '啟用查重，允許保存數據',
    enablecheckdRepeat2: '啟用查重，不允許保存數據',
    noOpacity: '不透明',
    auto: '自適應',
    forTableWidth: '與表單同寬',
    internationalCode: '國際編碼',
    customCode: '自定義編碼',
    option: '選項',
    newOption: '新選項',
    oneNewOption: '壹級新選項',
    twoNewOption: '二級新選項',
    threeNewOption: '三級新選項',
    sureDelCutomField: '確定刪除自定義字段(不可恢復)?',
    listLayout: '列表布局',
    max3RowData: '最多只能添加3行數據',
    max3ColumnData: '最多只能添加3列數據',
    biaochunPageNotSave: '標準頁面布局未保存',
    saveListLayoutSuccess: '保存列表布局成功',
    saveFail: '保存失敗',
    outLinkExtendlist: '外鏈擴展列表',
    extendNameRequire: '擴展名（必填）',
    extendValueRequire: '擴展值（必填）',
    extendNameRequire1: '拓展名必須填寫',
    extendValueRequire1: '拓展值必須填寫',
    jiexiAfterAutoInput: '解析後抽取字段自動填充到自定義字段中',
    customField: '自定義字段',
    jiexiField: '解析字段',
    valueDuiyingTo: '的值對應為',
    cutomJiexieFieldNotEmpty: '自定義字段和解析字段不能為空',
    formulaNew: '公式',
    addPage: '新增頁面',
    AppListLayout: '移動端布局',
    webform: 'web表單',
    biaozhunPage: '標準頁面',
    subPage: '子頁面',
    liushuiRuleNotEmpty: '流水號規則不能為空',
    oneOtionValue: '至少需要存在壹個選項值',
    bianhaoRuleNotEmpty: '編號規則不能為空',
    computeNotEmpty: '計算公式不能為空',
    thisOprateDelPageIsGoon: '此操作將永久刪除該頁面,是否繼續?',
    saevFailNetworkClickSyn:
      '保存頁面布局時存在網絡連接失敗信息, 為保證頁面布局正常使用,請點擊“同步”按鈕繼續操作',
    synSuccess: '同步成功',
    syn: '同步',
    modulePushSuccess: '模塊發布成功, 還可以繼續創建模塊哦~',
    goonCreate: '繼續創建',
    firstWebform: '第壹個web表單',
    webformNameNotEmpty: '名稱不能為空',
    webformPwdNotEmpty: '密碼不能為空',
    webformPwd6: '表單密碼長度6位',
    validationFieldNotEmpty: '驗證字段不能為空',
    fieldNotEmpty: '字段不能為空',
    sameWebformName: '存在相同的表單名稱, 是否為相同的活動?',
    approvalSaveUse: '保存並使用',
    approvalReset: '重置',
    approvalRevoke: '撤銷',
    approvalNodeAttr: '節點屬性',
    approvalSelectNode: '請選擇節點',
    approvalNodeName: '節點名稱',
    approvalInput10: '只能輸入10個字符',
    approvalBrancheCondtion: '分支條件',
    approvalSetBranche: '設置分支條件',
    approvalPerType: '審批人類型',
    approvalSelectPer: '選擇審批人',
    approvalPerStop: '終止審批人',
    approvalPerStopAfter: '只要終止審批人審批過後, 審批單就不再繼續往上流轉',
    approvalMode: '審批方式',
    approvalYici: '依次審批',
    approvalHuanjieYici: '本環節內審批人依次審批',
    approvalHuiqian: '會簽',
    approvalHuiqianInfo: '所有審批人同時收到審批, 且所有人需同意方可算審批通過',
    approvalHuoqian: '或簽',
    approvalHuoqianInfo: '所有審批人同時收到審批, 只需壹個人審批通過或拒絕即可',
    approvalStarePer: '發起人的',
    approvalDibu: '待審遞補',
    approvalzKongque: '若該審批人空缺, 由其在通訊錄中的上級部門負責人代審批',
    approvalSet: '審批設置',
    approvalMustSingtrue: '審批通過時必須手寫簽名',
    approvalSingtrue: '審批通過時可手寫簽名',
    approvalcaosong: '選擇抄送人',
    approvalRejectMode: '駁回方式',
    approvalKefuxuan: '審批人可以根據審批內容選擇駁回方式, 可復選',
    approvalBohui1: '駁回給上壹節點審批人',
    approvalBohui2: '駁回到發起人',
    approvalBohui3: '駁回到指定節點',
    approvalBohui4: '駁回並結束',
    approvalCaosongMode: '抄送方式',
    approvalPassCaosong: '審批通過抄送',
    approvalRejectCaosong: '審批駁回抄送',
    approvalEditField: '當前環節審批人與抄送人能夠看見的字段, 審批人能夠編輯的字段',
    approvalIsshow: '可見',
    approvalProcessAttr: '流程屬性',
    approvalApplicant: '申請人',
    approvalProcessMode: '流程方式',
    approvalFixedProcess: '固定流程',
    approvalAnzhao: '按照設定好的流程來執行審批',
    approvalFreeProcess: '自由流程',
    approvalNotSetProcess: '不需要設定流程, 由前臺操作人來決定審批流轉流程',
    approvalFaqiShow: '發起人可見',
    approvalFaqiNotShow: '發起人不可見',
    approvalProcessRemind: '流程提醒',
    approvalEveryNodeRemind: '每個節點審批通過都提醒發起人',
    approvalAllowCehui: '允許發起人撤回審批',
    approvalAllowCehui1: '是否允許發起人在審批單未被審批之前撤回',
    approvalAllowZhuanjiao: '允許審批人轉交審批',
    approvalAllowCaosong1: '允許發起人抄送審批',
    approvalAllowCaosong2: '允許審批人抄送審批',
    approvalAllowCaosong3: '允許抄送人抄送審批',
    noSkipHistoryNode: '不跳過歷史節點',
    noSkipHistoryNodeRemark: '驳回到的節點通过后重新依次审批',
    skipHistoryNode: '跳過歷史節點',
    skipHistoryNodeRemark:
      '驳回到的節點通过后直接返回本節點；例：1,2,3三个節點，3驳回至1，如自动跳过，1完成后跳过2直接到3',
    approvalerRepeat: '審批人去重',
    approvalDelProcess: '刪除流程',
    approvalLiuruNode: '任意條件均可流入該節點',
    approvalLiuruNode1: '滿足指定條件才可流入該節點',
    approvalSingle: '單人審批',
    approvalMore: '多人審批',
    approvalDeparmentSingle: '部門負責人-單級',
    approvalDeparmentMore: '部門負責人-多級',
    approvalZhidingRole: '指定角色',
    approvalMy: '發起人自己',
    approvalOneDeparment: '第壹級部門負責人',
    approvalTwoDeparment: '第二級部門負責人',
    approvalThreeDeparment: '第三級部門負責人',
    approvalFourDeparment: '第四級部門負責人',
    approvalDontAutoRepeat: '不啟用自動去重',
    approvalDontAutoRepeat1: '同壹個審批人在流程中多次出現, 自動去重',
    approvalDontAutoRepeat2: '同壹個審批人在流程中連續出現, 自動去重',
    approvalProcessStartNode: '流程開始節點',
    approvalProcessEndNode: '流程結束節點',
    approvalNewNode: '新節點',
    approvalAddNode: '添加節點',
    approvalNodeNameNotEmpty: '節點名稱不能為空',
    approvalPleaseSelectPer: '請選擇審批人',
    approvalSaveSuccess: '保存審批流程成功',
    approvalSaveTakeEffectSuccess: '保存審批流程成功且已生效',
    approvalCreateModuleThen: '請先創建模塊再創建流程',
    approvalInitNotDel: '初始化的流程節點不能刪除',
    approvalResetIsOk:
      '重置後流程會恢復初始化樣式,所有已經設置好的規則都將會被還原; 你確定要重置嗎?',
    approvalContonMax2: '條件大於兩個才能設置高級條件',
    approvalDelIsGoon: '此操作將永久刪除該流程, 是否繼續?',
    approvalDelSuccess: '刪除流程成功',
    approvalDelFail: '刪除流程失敗',
    pleaseSelectMatrix: '請選擇矩陣',
    pleaseSelectJobPos: '請選擇矩陣下的崗位',
    pleaseSelectDepCompoment: '請選擇矩陣對應的部門組件',
    unsetMatrix: '未設置矩陣',
    unsetJopPos: '未設置崗位',
    to: '到',
    fenlanHaveFuzeren: '當前分欄存在【負責人】字段, 將其移動到其他分欄後才可刪除分欄?',
    selFenlanMoveEnable: '通過刪除分欄, 將會把分欄內的字段移除到未使用字段中?',
    newAddColumns: '新增分欄',
    clickSigntrue: '點擊簽名',
    notSaveIsSaveLayout: '布局未保存, 是否保存布局?',
    columns: '分欄',
    unusedFields: '未使用字段',
    customColor: '自定義顏色',
    color: '顏色',
    textColorSet: '文本顏色設置',
    selectIcon: '選擇圖標',
    uploadIcon: '上傳圖標',
    max10: '最大10',
    max100: '最大100',
    plsaseSelectComponents: '請從左側拖入字段～',
    submitSuccess: '提交成功',
    textDesc: '文本描述',
    splitLine: '分割線',
    button: '按鈕',
    pictureCarousel: '圖片輪播',
    videoShow: '視頻展示',
    staticMap: '靜態地圖',
    timer: '計時器',
    SignIn: '簽到',
    fullname: '姓名',
    form: '表單',
    saveAndGoback: '保存返回',
    listFieldWidth: '列表寬度',
    pleaseSelectField: '請選擇字段',
    content: '內容',
    buttonStyle: '按鈕樣式',
    defaultWebform: '默認',
    customWebform: '自定義',
    textSize: '文字大小',
    buttonIcon: '按鈕圖標',
    buttonFillet: '按鈕圓角',
    buttonHeight: '按鈕高度',
    autoText: '適應文字',
    uploadButtonStyle: '上傳按鈕樣式',
    size: '尺寸',
    proposalWidthHeight: '建議寬高 ＜375像素x80像素',
    clickEvent: '點擊事件',
    selectType: '選擇類型',
    lickAddress: '鏈接地址',
    selectLickAddress: '請輸入鏈接地址',
    sendEmali: '發郵件',
    linetype: '線型',
    linewidth: '線寬',
    linecolor: '線條顏色',
    clickUpload: '點擊上傳',
    carouselCount: '輪播數量',
    lickAddressDesc: '鏈接地址/描述',
    inputDescContent: '請輸入描述內容',
    baseSet: '基礎設置',
    carouselSpeed: '輪播速度',
    pictrueHeight: '圖片高度',
    videoAddress: '視頻地址',
    supportTYAT: '支持騰訊視頻、優酷、愛奇藝、土豆',
    outMediaPasteInput: '請將外部媒體地址粘貼至輸入框',
    showAddress: '顯示地點',
    inputTargetAddress: '輸入目標地址',
    timerType: '計時器類型',
    inmapShowBiaoji: '在地圖標記點上顯示信息框',
    proposalPic750450: '建議圖片尺寸為750*450',
    jishi: '計時',
    daojishi: '倒計時',
    intoValueSecond: '初始值(秒)',
    shiwFormat: '顯示格式',
    arrivalDate: '到達日期',
    fromField: '表單字段',
    selectFieldAddToFrom: '選擇字段添加到表單',
    jumpLink: '跳轉鏈接',
    title: '標題',
    thankInputFeedback: '我們已收到您的反饋, 感謝填寫',
    formSet: '表單設置',
    formName: '表單名稱',
    onlyPcVisit: '僅PC端訪問生效',
    fieldStyle: '字段樣式',
    contetnBg: '內容背景',
    titleStyle: '標題樣式',
    inputAuth: '填寫權限',
    set6Pwd: '設置6位密碼',
    linkExpand: '鏈接拓展',
    linkExpandInfo: '對同壹個表單賦予擴展屬性值使該表單擁有多個鏈接地址, 用於標識不同數據',
    linkExpandInfo2:
      '對同壹個表單賦予擴展屬性值使該表單擁有多個鏈接地址, 用來標識收集到的不同數據的來源渠道。',
    expandOutlink: '擴展外鏈',
    expandOutlinkList: '擴展外鏈列表',
    shareSet: '分享設置',
    shareSetInfo: '分享設置信息用於分享表單時顯示的樣式內容, 用於分享到第三方平臺',
    whetherSignin: '是否簽到',
    enable: '啟用',
    close: '關閉',
    activityTheme: '活動主題',
    signinButton: '簽到按鈕',
    signinTypeface: '簽到字體',
    fypefaceColor: '字體顏色',
    formStyle: '表單樣式',
    signinbg: '簽到背景',
    restoreDefault: '恢復默認',
    use375667: '建議使用375*667尺寸的圖片',
    validationField: '驗證字段',
    signinRestriction: '簽到限制',
    openSignin: '允許開放式簽到',
    submitSuccessTips: '提交成功提示',
    callUp: '撥打電話',
    sendMessage: '發短信',
    solidLine: '實線',
    dottedLine: '虛線',
    dotMarking: '點劃線',
    doubleSolidLine: '雙實線',
    max4Pic: '最多添加4張圖片',
    max5Pic: '最多添加5張圖片',
    inputTabge50to1000: '輸入範圍：50-1000',
    inputTabge250to1000: '輸入範圍：250-1000',
    addAddress: '添加地址',
    addForm: '新建表單',
    visitAuth: '訪問權限',
    release: '發布',
    sureDelWebform: '確定要刪除該web表單嗎?',
    sureReleaseWebform: '確定要發布該web表單嗎?',
    sureCloseWebform: '確定要關閉該web表單嗎?',
    releaseSuccess: '發布成功',
    closeSuccess: '關閉成功',
    copiedToClipboard: '已復制至剪切板',
    column: '欄目',
    noSelectFieldNoAttr: '沒有選擇字段或該字段沒有屬性',
    fieldEnglishName: '字段英文名稱',
    locking: '鎖定',
    WholeCompany: '全機構',
    teshuontrol: '特殊控制',
    allowRemove: '允許移除',
    allowMove: '允許移動',
    allowDelete: '允許刪除',
    customOption: '自定義選項',
    referenceTasktTag: '關聯協作任務標簽數據',
    referenceProjectTag: '關聯本項目標簽數據',
    referenceCommodity: '關聯商品分類數據',
    projectAndCustomData: '項目和自定義數據',
    networkFialAgainCheck: '網絡連接失敗, 請檢查您的網絡重新訪問',
    multilingualSettings: '多語言設置',
    Languages: '語種',
    addMoreLanguages: '添加語種',
    backgroundMusic: '背景音樂',
    sms: '短信驗證',
    smsTip: '使用該功能前請先在【系統管理】-【短信管理】中進行短信平臺賬戶綁定。',
    needSms: '需要短信驗證',
    code_error: '請輸入驗證碼',
    getcode: '獲取驗證碼',
    appAdminer: '應用管理員',
    appAdminerSet: '應用管理員設置',
    appHomepage: '應用首頁',
    quoteReport: '引用數據分析',
    delquoteReport: '刪除引用數據分析',

    // 2020-10-15
    addDescription: '添加說明',
    fromTamplateCreate: '從模板創建',
    fromExcelImport: '從Excel導入',
    sureDelModule: '確定要刪除模塊',
    delModuleTips: '?刪除後該模塊將不可恢復且模塊內的數據也同時被刪除',
    dontWantToReport: '沒有想要的數據分析?',
    gotoCreate: '去創建',
    appDescFirstShow: '應用說明，用戶第壹次訪問應用會彈出該說明',
    excelImportInfo1: '1、支持 20MB 以內的xlsx格式文件，最多允許上傳10000條;',
    excelImportInfo2: '2、目前不支持導入創建子表單、關聯關系、自動編號、流水號等;',
    excelImportInfo3: '3、請將字段名稱顯示在第壹行中，不能存在合並的單元格;',
    excelImportInfo4: '4、列子段數量不得超過200列;',
    importDataError: '導入數據失敗，請查看已下載的錯誤日誌',
    tamplatePreview: '模板預覽',
    sampleTemplate: '示例模板',
    pleaseAddFile: '請添加文件',
    pleaseChooseReport: '請選擇需要引用的數據分析',
    determineDelAppHomepage: '確定要刪除該應用首頁嗎?',
    appHaveAppHomepage: '應用下存在應用首頁，請先刪除應用首頁?',
    formDesign: '表單設計',
    listSetting: '列表設置',
    detailLayout: '詳情布局',
    subpageNameMustfill: '子頁面名稱不能為空',
    subpageNameNotRepeat: '子頁面名稱不能重復，請修改後重新保存',
    fieldSetPayNotBallback: '字段支付功能已開啟，但未設置對應回填字段',
    automationRules: '自動化規則',
    layoutTipsJudge1: '關聯模塊屬性為空',
    layoutTipsJudge2: '關聯字段屬性為空',
    layoutTipsJudge3: '二級或三級至少添加壹個選項',
    layoutTipsJudge4: '選項不能為空',
    layoutTipsJudge5: '選項不能重復',
    layoutTipsJudge6: '壹個模塊僅能使用壹個工商信息查詢',
    layoutTipsJudge7: '請至少選擇壹個對應字段',
    layoutTipsJudge8: '智能插件中身份證名稱必填',
    approvalCheckRepeat: '審批查重',
    approvalCheckRepeat0: '審批查重設置',
    approvalCheckRepeat1: '審批查重設置(審批中數據查重)',
    approvalCheckRepeat2:
      '審批查重設置(用於審批中的數據進行查重，不允許再次提交相同條件審批中的數據（審批狀態=審批中、待審批時作為校驗數據）)',
    approvalCheckRepeat3: '查重規則條件',
    approvalCheckRepeat4: '設置查重規則條件',
    approvalCheckRepeat5: '可以使用 OR,AND,NOT和英文括號將上列條件組成邏輯關系;',
    approvalCheckRepeat6:
      '例如：(1 AND 2) OR 3 表示第壹和第二個條件與關系後，再和第三個條件或運算;',
    approvalCheckRepeat7: '在符合查重條件後，顯示此消息',
    approvalCheckRepeat8: '在滿足條件公式時提交保存動作',
    preciseQuery: '精確查詢',
    intervalDuplicateChecking: '區間查重',
    approvalContionShowInfo: '在符合查重條件後，顯示此消息 必填',
    gobackJuheTable: '返回聚合表',
    computer: '電腦',
    rightShowValue: '在右邊設置列表顯示數值',
    allData: '全部數據',
    listValue: '列表數值',
    mobileTerminal: '移動端',
    moduleDataList: '模塊數據列表',
    chooseShowFields: '選擇顯示字段',
    chooseReportCharts: '選擇數據分析圖',
    chooseVauleChart: '選擇數值圖表',
    listSetUpdate: '列表設置有更改，是否需保存?',
    subpageSetting: '子頁面設置',
    delSubpage: '刪除子頁面',
    fromLeftDraggableField: '可從左側拖拽添加字段～',
    subformFieldMustLeft: '子表單字段只能從左側 "字段組件" 中拖入',
    subformNotDraggField: '子表單中不支持此組件，請添加其它組件',
    subformDontToMain: '子表單字段不能拖入主表中',
    appearanceSet: '外觀設置',
    addColumn: '添加分欄',
    pleaseDraggToSubform: '請拖入名稱對應的子表單中',
    draggableInAddFields: '（拖拽添加字段）',
    subpageName: '子頁面名稱',
    fieldDescription: '字段描述',
    digitalUnit: '數字單位',
    pleaseInputUnit: '請輸入單位，如“個”',
    formluaMarkColor: '用於對公式值進行背景顏色標識',
    shibieType: '識別類型',
    shibieCallBackSet: '識別回填設置',
    callBackSet: '回填設置',
    callBackSetInfo1: '用於將查詢到的信息自動回填填充到字段中，提高準確性和效率，選填',
    payFunction: '支付功能',
    payFunInfo1: '可以通過掃碼進行微信支付和支付寶支付',
    payFunInfo2: '支付字段對應設置',
    payFunInfo3: '對應設置用於將支付反饋字段填充到自定義組件中顯示',
    payFunInfo4: '請先至【後臺】-【接口集成】-【第三方接口】-【支付接入】中開通支付功能',
    payFunInfo5:
      '已開啟支付功能，壹個模塊內僅允許壹個字段開啟支付，如要開啟當前字段，請先將原字段支付功能進行關閉',
    smartPlugIn: '智能插件',
    smartPlugInInfo:
      '使用該功能前至【接口集成】-【第三方平臺】-【阿裏雲集成】中設置對應阿裏雲接口賬戶，無配置接口賬戶則該功能無效',
    shibieIDcard: '身份證識別',
    checkSet: '校驗設置',
    checkSetInfo1: '用於校驗姓名和身份證號是否匹配，必填',
    shoukuanInof1: '收款金額',
    shoukuanInof2: '收款方式',
    shoukuanInof3: '收款狀態',
    shoukuanInof4: '收款時間',
    shoukuanInof5: '交易號',
    idCardMudtFill: '身份證名稱必填',
    mustOnlyOneField: '請至少選擇壹個對應字段',
    chooseFormName: '選擇表單名稱',
    checkRepeatShowInfo1: '在符合查重條件後，顯示此消息',
    checkRepeatShowInfo2: '不允許提交',
    checkRepeatShowInfo3: '允許提交，提示以上消息且支持選擇是否繼續保存',
    bianhaoRule: '編號規則',
    nameField: '名稱字段',
    layout: '布局',
    businessComponey: '業務組件',
    clickComToLayout: '點擊組件到布局中使用',
    addRemark: '添加備註',
    clickRightInputUrl: '點擊在右側設置輸入URl鏈接',
    clickRightAddField: '點擊在右側設置添加顯示字段',
    headerTitleSet: '頭部標題設置',
    displayStyle: '顯示風格',
    biaozhun: '標準',
    cardStyle: '卡片樣式',
    showHeaderFiled: '顯示頭部字段',
    fieldShowStyle: '字段顯示樣式',
    upDown: '上下',
    letRight: '左右',
    allShowStyle: '整體顯示樣式',
    zuheShow: '組合顯示',
    aloneShow: '單獨顯示',
    showField: '顯示字段',
    more12Fields: '最多顯示12個字段',
    showDesc: '顯示描述',
    showDescInfo1: '描述字段為布局中的多行文本字段',
    addTagFields: '添加標簽字段',
    tagFieldsinfo1: '標簽字段為布局中的下拉選項（多選）字段',
    valueCountSet: '數值統計設置',
    lineCount: '單行數量',
    addGaojiFormula12: '添加高級公式字段，最多顯示12個',
    tabSet: 'Tab頁簽設置',
    tabShowStyle: 'Tab展示樣式',
    tab: '頁簽',
    biaoqian: '標簽',
    tabWaiguan: '頁簽外觀',
    style: '風格',
    tabPosition: 'Tab頁簽位置',
    tabContent: '頁簽內容',
    qianruPageSet: '嵌入頁面設置',
    titleName: '標題欄名稱',
    inputUrl: '輸入URL',
    qianruUrlView: '嵌入URL預覽',
    qianruUrlViedoPic: '可嵌入網頁、視頻、圖片鏈接',
    showStyle: '展示的樣式',
    defaultShow: '默認顯示',
    timeListSet: '時間軸設置',
    sortFunction: '排序方式',
    defaultStyle: '默認樣式',
    style1: '樣式壹',
    style2: '樣式二',
    style3: '樣式三',
    headerShow: '頭部顯示',
    detailsData: '詳細資料',
    valueCount: '數值統計',
    carousel: '輪播圖',
    carouselDescription: '點擊在右側設置輪播圖',
    qianruPage: '嵌入頁面',
    tabYeqian: 'Tab頁簽',
    StyleOne: '風格壹',
    StyleTwo: '風格二',
    StyleThree: '風格三',
    StyleFour: '風格四',
    StyleFive: '風格五',
    layoutDetailJudge1: '請至少選擇壹個頭部顯示字段',
    layoutDetailJudge2: '請選擇頭部顯示標簽',
    layoutDetailJudge3: '請選擇頭部描述字段',
    layoutDetailJudge4: '嵌入頁面URL不能為空',
    layoutDetailJudge5: '存在空頁簽布局，請刪除後再保存',
    layoutDetailJudge6: '時間軸設置有誤',
    layoutDetailJudge7: '數值統計字段不能為空',
    layoutDetailJudge8: '請選擇時間軸字段',
    layoutDetailJudge9: '請輸入嵌入網頁的URL',
    layoutDetailJudge10: '嵌入網頁的URL格式不正確',
    idCardCheck: '身份證號校驗',
    idCard: '身份證號',
    moreLanguageSet: '多語言設置',
    dragpaneltouse: '拖動組件到面板使用',
    formpage: '表單頁面',
    checkinpage: '簽到頁面',
    formfieldontherightside: '請在右側“表單字段”添加',
    signinnow: '立即簽到',
    signedupyet: '還沒有報名？',
    signup: '去報名',
    namebackground: '名稱底色',
    signinsettings: '簽到設置',
    passwordaccess: '密碼訪問',
    password: '密碼',
    published: '已發布',
    unpublished: '未發布',
    extendName: '擴展名',
    link: '鏈接',
    unnamedform: '未命名表單',
    workFlowTrigger: '在數據自動新建後（新建與更新執行操作中的新建數據觸發）',
    scheduleContent: '日程內容',
    referneceDefTriggerData: '關聯：默認關聯引用當前觸發新建日程數據',
    everyYear: '每年',
    injionMemberNotEmpty: '參與人不能為空',
    starttimeLessEndtime: '開始時間不能大於結束時間',
    remindtimeInputJudge: '提醒時間請輸入正整數',
    starttimeIsError: '開始時間填寫有誤',
    baseTemplate: '基礎模版',
    delCustomTemplate: '是否刪除該自定義模板?',
    formatCheck: '格式校驗',
    picTextShitbie: '圖文識別',
    saveBtn: '保存按鈕',
    cancelBtn: '取消按鈕',
    buttonSetting: '按鈕設置',
    more5Btn: '最多顯示5個按鈕',
    showBtns: '顯示的按鈕',
    hiddneBtns: '收起的按鈕',
    dataSubmitCheck: '數據提交校驗',
    submitCheckJuheInfo: '在滿足條件公式下顯示此消息，且提交失敗',
    juheCheckInfo1: '公式內容必填',
    juheCheckInfo2: '在滿足條件公式下，顯示的消息內容必填',
    checkRepeatRoleSet: '查重規則設置',
    gobackHomepage: '返回首頁',
    addLanguage: '添加語言',
    addLanguageMustFill: '添加的語種,列名稱必填',
    picturedisplay: '圖片展示',
    dongtaiField: '動態字段',
    currentDep: '當前部門及下級部門',
    principalSuperior: '負責人上級',
    principalDeartment: '負責人所屬部門',
    areyouSureDel: '確定要刪除該儀表盤數據嗎?',

    // 2020-12-25
    NodeTimeLimit: '節點限時',
    NodeTimeLimitInfo:
      '為節點設置處理截止時間，並可自動提醒節點負責人處理待辦，如果長時間不處理可自動提交或回退，避免流程停滯。',
    NodeTimeLimitInfo1: '節點超時觸發超時處理方式',
    NodeTimeLimitSet: '節點限時設置',
    emailRemind: '郵件提醒',
    emailRemindInfo:
      '發件人為審批單的申請人，申請人需綁定郵件才可以使用該功能，若未綁定則郵件不回發送',
    emailRemindInfo1:
      '發件人為當前模塊的負責人，負責人需綁定郵件才可以使用該功能，若未綁定則郵件不會發送',
    emailRemindNodePer: '郵件提醒節點審批人、抄送人',
    emailRemindNodePer1: '郵件提醒節點執行人',
    emailTemplateSet: '郵件模板設置',
    nodeEndtime: '節點審批截止時間',
    flowToCurrentNode: '流程到達該節點',
    PostTimeout: '後超時',
    TimeoutProcessingMode: '超時處理方式',
    AddProcessingMethod: '添加處理方式',
    ProcessingMethod: '處理方式',
    autoRemindTime: '自動提醒時間',
    Reminder: '提醒人',
    remindContent: '提醒內容',
    autoRejectTo: '自動駁回到',
    autoProcessingSet: '自動處理設置',
    TimeoutPerRemind: '超時後對指定的人員進行提醒',
    autoSubmitTime: '自動提交時間',
    autoRejectTime: '自動駁回到時間',
    nodeProcessingEndtime: '在節點處理截止時間',
    autoSubmitNextNode: '自動提交到下壹審批節點',
    nodeReviewer: '節點審批人',
    PreviousNode: '上壹個節點',
    ProcessSponsor: '流程發起人',
    customTime: '自定義時間',
    formDatemineFields: '根據表單內日期時間字段',
    autoRemind: '自動提醒',
    autoSubmit: '自動提交',
    autoReject: '自動駁回',
    atThatTime: '當時',
    autoRemindItemNotEmpty: '自動提醒時間不能為空',
    autoRemindTimeInteger: '自動提醒時間必須為正整數',
    nodeApprovalTimeRequired: '節點審批截止時間字段必填',
    remindContentRequired: '提醒內容必填',
    TimeoutReminderContent: '超時提醒內容',
    approvalTimeoutInfo: '審批限時即將超時',
    flowApprovalTimeout: '審批限時已超時',
    PleasePositiveInteger: '請輸入正整數',
    mustYouApproval: '的申請需要您審批處理',
    creatingYibiaopan: '創建儀表盤',
    editYibiaopan: '編輯儀表盤',
    yibiaopanNameRequired: '儀表盤名稱必填',
    LimitSettings: '限制設置',
    PhotoUploadOnly: '僅允許拍照上傳',
    listDetailEditSet: '列表編輯和詳情編輯設置',
    listDetailEditSetInfo:
      '用於對列表編輯和詳情編輯功能的開關，關閉後將不可在列表或詳情對單個字段進行編輯，只能點擊編輯按鈕進行編輯',
    submitApproval: '單據提交即審批',
    submitApprovalDesc:
      '開啟：單據儲存後直接進入審批，一旦開啟【全局設置-自定義按鈕-觸發事件：發起審批】不再生效；關閉：單據無法進入審批，需要在【全局設置-自定義按鈕-觸發事件：發起審批】配置，儲存-點擊自定義按鈕進入審批；',
    clickRightSetTabcontent: '點擊在右側設置添加頁簽內容',
    newBuildYibiaopan: '新建儀表盤',
    customBtnAfterClick: '在自定義按鈕點擊後',
    approvalStatusAfterUpdate: '在審批狀態更新後',
    selectTargetCustombtn: '請選擇需要觸發的自定義按鈕',
    selectTargetApprovalStatus: '請選擇需要監聽的審批狀態',
    serialNumber: '編號',
    // 20210305
    signinpage: '簽到後顯示頁面',
    Industry_empty: '所屬行業不能為空',
    appType_empty: '應用分類不能為空',
    subformSort: '子表單排序',
    subformSortDroggable: '子表單順序上下拖動',

    // 2021-03-31
    formulaSubmitSaveInfo: '在滿足條件公式時提交保存動作',
    moduleNameJudge: '名稱僅為漢字、英文字母和數字',
    ListNumberSettings: '列表數量設置',
    listNumSwitch: '用於對列表顯示數量的開關控製，勾選則可以選擇該選項，不勾選則無該選項',
    Article100PerPage: '100條/頁',
    Article500PerPage: '500條/頁',
    SubformsRecordDynamics: '子表單記錄動態',
    locationSetting: '定位設置',
    locationNearbyRange: '定位附近可選範圍',
    subformDynamicTemplate: '訂單明細子表單日誌記錄模板：',
    subformDynamicTip1: '在「訂單明細中」新建了序號為【5】的產品編號【CP00001】',
    subformDynamicTip2:
      '在「訂單明細中」中序號【5】產品編號為【CP00001】的【數量】從【52】改為【100】',
    subformDynamicTip3: '在「訂單明細中」刪除了序號為【5】的產品編號【CP00001】',
    subformDynamicTip4: '子表單字段唯一標識',
    subformDynamicTip5: '子表單記錄動態字段包含：',
    subformNotSetFields: '子表單未設置字段',
    subformDynamicTip4required: '子表單字段唯一標識必填',
    subformDynamicTip5required: '子表單記錄動態字段必填',
    UppercaseLettersNum: '大寫字母+數字',
    LowercaseLettersNum: '小寫字母+數字',
    UppercaseLowercaseLettersNum: '大小寫字母+數字',
    AssociatedTarget: '關聯目標',
    GetSssociatedModuleValue: '獲取關聯模塊值',
    ComponentName: '組件名稱',
    DynamicTimeNull: '動態時間為空值時顯示',
    ReadFields: '讀取字段',
    SubmitNum_1: '提交數量控製',
    SubmitNum_2: '關聯模塊提交數量控製',
    SubmitNum_3: '超過提交上限，提示：',
    SubmitNum_4: '提交數據有校驗（未設置則為有效數據）',
    SignInShowInformation: '簽到未預約顯示信息',
    GetSssociationMapping: '通過關聯映射獲取',
    allApp: '所有應用',
    createAppFromTemplate: '從模板創建應用',
    allowSenderRevoke: '允許發起人撤銷審批中的審批單',
    listPtimization: '列表性能優化',
    listPtimizationInfo: '用於對列表顯示的總數和分頁進行控製，在大數量的情況下優化性能',
    listPageSet: '列表分頁',
    showBeforeOnly: '僅顯示前',
    listGlobalSearch: '列表全局搜索',
    listGlobalSearchInfo:
      '開啟後在列表顯示全局搜索功能，可通過模糊搜索搜索文本、數字類型的組件（模塊字段少於30個字段時開啟，該功能性能損耗比較大，建議謹慎開啟）',
    listDataShowControl: '列表數據顯示控製',
    listDataShowControlInfo:
      '僅用於當前模塊數據量大使用，勾選則全部子菜單中，列表的數據默認不顯示，需要在列字段中進行篩選才會顯示篩選後的數據。',
    checkListDataHiddle: '勾選即列表數據不顯示',
    fieldIndex: '字段索引',
    fieldIndexInfo: '勾選後該字段在數據庫中建立字段索引功能，優化數據庫查詢速度。',
    visiblePermission: '可見權限',
    editPermission: '編輯權限',
    approvalNodeLineError1: '開始節點不能直接連接結束節點',
    approvalNodeLineError2: '必須有連入線和連出線',
    approvalNodeLineError3: '沒有',
    approvalNodeLineError4: '連出線',
    approvalNodeLineError5: '連入線',
    approvalNodeLineError6: '開始節點必須在第一個階段中'
  }
}
